// extracted by mini-css-extract-plugin
export var modal = "_c7-0";